import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CompanyListComponent } from './components/company/company-list/company-list.component';
import { CompanyListItemComponent } from './components/company/company-list-item/company-list-item.component';
import { AffiliateItemComponent } from './components/department/affiliate-item/affiliate-item.component';
import { TransferArenaCashComponent } from './components/transfer-arena-cash/transfer-arena-cash/transfer-arena-cash.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TransferArenaMultipleAccountsComponent } from './components/transfer-arena-cash/transfer-arena-multiple-accounts/transfer-arena-multiple-accounts.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { EarnPointsCardComponent } from './components/earn-points-card/earn-points-card.component';
import { ProgressBarComponent } from './components/average-points/progress-bar/progress-bar.component';
import { LeaderboardComponent } from './components/leaderboard/leaderboard.component';
import { RedSoxNationComponent } from './components/red-sox-nation/red-sox-nation.component';
import { RouterModule } from '@angular/router';
import { JokesCardComponent } from './components/jokes-card/jokes-card.component';
import { ProgressBarGameAttendanceComponent } from './components/progress-bar-game-attendance/progress-bar-game-attendance.component';
import { NotificationHubComponent } from './components/notification/notification-hub.component';
import { NotificationCenterToastComponent } from './components/notification/notification-center/toast/notification-center-toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NotificationItemComponent } from './components/notification/notification-center/notification-item/notification-item.component';
import { NotificationManagementComponent } from './components/notification/notification-management/notification-management.component';
import { NotificationGroupItemComponent } from './components/notification/notification-management/notification-group-item/notification-group-item.component';
import { NotificationToastComponent } from './components/notification/notification-center/notification-toast/notification-toast.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FeaturedSurveysComponent } from './components/featured-surveys/featured-surveys.component';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LeaderboardInitialsPipe } from './components/leaderboard/leaderboard-initials.pipe';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

@NgModule({
  declarations: [
    CompanyListComponent,
    CompanyListItemComponent,
    AffiliateItemComponent,
    TransferArenaCashComponent,
    TransferArenaMultipleAccountsComponent,
    EarnPointsCardComponent,
    ProgressBarComponent,
    LeaderboardComponent,
    RedSoxNationComponent,
    JokesCardComponent,
    ProgressBarGameAttendanceComponent,
    NotificationHubComponent,
    NotificationCenterToastComponent,
    NotificationItemComponent,
    NotificationManagementComponent,
    NotificationGroupItemComponent,
    NotificationToastComponent,
    FeaturedSurveysComponent,
    LeaderboardInitialsPipe,
  ],
  imports: [
    NgbModule,
    SharedModule,
    CommonModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CountdownModule,
    ToastrModule.forRoot(),
    InlineSVGModule.forRoot(),
    RouterModule,
    PipesModule,
    DirectivesModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    CompanyListComponent,
    CompanyListItemComponent,
    AffiliateItemComponent,
    TransferArenaCashComponent,
    TransferArenaMultipleAccountsComponent,
    EarnPointsCardComponent,
    ProgressBarComponent,
    LeaderboardComponent,
    RedSoxNationComponent,
    JokesCardComponent,
    ProgressBarGameAttendanceComponent,
    NotificationHubComponent,
    NotificationCenterToastComponent,
    NotificationManagementComponent,
    NotificationToastComponent,
    FeaturedSurveysComponent,
  ],
  // entryComponents: [NotificationCenterToastComponent],
})
export class ClubModule {}
